
export enum IntentHandlerType
{
	URI,
	Dialog,
	FrontEndAction
}
